import DaisyBaseService from './../../../services/DaisyBaseService';

/**
 * this is the order service to handle the communication with the daisy backend
 **/
export default class OrderService extends DaisyBaseService {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		super($injector);
		this.$timeout = $injector.get('$timeout');
	}
	
	/**
	 * get all orders numbers
	 **/
	getOrders() {
		let functionUrl = '/ladeAuftragsnummern';
		let data = {};

		return this.doPost(functionUrl, data);
	}

	/**
	 * get order number
	 * @param {number} id - order number
	 **/
	getOrder(id) {
		let functionUrl = '/ladeAuftragsnummer';
		let data = {id: id};

		return this.doPost(functionUrl, data);
	}
}
